export enum DialogCloseResponse {
    CANCEL = 'cancel',
    CONFIRM = 'confirm',
    CLOSE = 'close',
}
